import { type AxiosError } from 'axios'
import * as Sentry from '@sentry/nextjs'
import { buildAxiosInstance } from '../../../utils/apiUtils'
import { globalUserProxy } from '../../../proxies/globalUserProxy'
import { type GlobalUserType } from '../../../types/GlobalUserType'
import { handleSignOut } from '../../navigation/Navbar/Account/components/utils'

interface ResponseData {
  user: GlobalUserType
}

interface Response {
  data: ResponseData | null
  error: string | null
}
const determineUnauthorized = (e: Error): void => {
  const status = (e as AxiosError<Response>).response?.status
  if (status === 401) {
    globalUserProxy.apiCall.error = '401 Unauthorized. Redirecting to login'
    setTimeout(() => { void handleSignOut() }, 5000)
  }
}

export const executeRetrieveUser = async (): Promise<GlobalUserType | undefined> => {
  try {
    globalUserProxy.apiCall.loading = true
    globalUserProxy.apiCall.error = null

    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/user_profile/retrieve')
    const user = response.data?.data?.user
    if (user) {
      globalUserProxy.user = user
      Sentry.setUser({ email: user.email, id: String(user.id) })
      return user
    }
  } catch (e) {
    if (e instanceof Error) {
      globalUserProxy.apiCall.error = e.message
      determineUnauthorized(e)
    }
  } finally {
    globalUserProxy.apiCall.loading = false
  }
}
